import { Component, Input, OnInit } from '@angular/core';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { GetSurveys$Json$Params } from '../../../api/fn/survey/get-surveys-json';
import { ToastService } from '../../../services/toast.service';
import { ClientSurveyModel } from './../../../api/models/client-survey-model';
import { SurveyService } from './../../../api/services/survey.service';
import { BaseAccountInfoComponent } from '../../BaseAccountInfo/BaseAccountInfo.component';
import { AccountInfoService } from '../../../services/account-info.service';
import { SurveyResponseService, SurveyVersionService } from '../../../api/services';
import { forkJoin, lastValueFrom } from 'rxjs';
import { DeleteSurveyVersionsAsync$Json$Params } from '../../../api/fn/survey-version/delete-survey-versions-async-json';
import { DeleteSurveyAsync$Json$Params } from '../../../api/fn/survey/delete-survey-async-json';
import { DeleteSurveyResponsesAsync$Json$Params } from '../../../api/fn/survey-response/delete-survey-responses-async-json';

@Component({
  selector: 'app-survey-history-grid',
  templateUrl: './survey-history-grid.component.html',
  styleUrls: ['./survey-history-grid.component.scss'],
})
export class SurveyHistoryGridComponent 
  extends BaseAccountInfoComponent
  implements OnInit {
  @Input() matterId: number;
  @Input() matterNumber: string | null | undefined;
  @Input() surveyTypeId: number;
  @Input() month: number;
  @Input() year: number;
  surveys: ClientSurveyModel[] = [];
  faCircleNotch = faCircleNotch;
  isSurveyHistoryLoading = true;

  constructor(
    private toastService: ToastService,
    private surveyService: SurveyService,
    private surveyVersionService: SurveyVersionService,
    private surveyResponseService: SurveyResponseService,
    accountInfoService: AccountInfoService
  ) {
    super(accountInfoService);
  }

  override ngOnInit() {
    super.ngOnInit();

    if (this.matterId) {
      this.loadSurveyHistory();
    }
  }

  isDeleting: boolean = false;

  loadSurveyHistory() {
    this.isSurveyHistoryLoading = true;
    let getparams: GetSurveys$Json$Params = {
      caseId: this.matterId,
      surveyTypeId: this.surveyTypeId,
      skip: 0,
      take: 1000,
    };
    this.surveyService.getSurveys$Json$Response(getparams).subscribe({
      next: (r) => {
        this.isSurveyHistoryLoading = false;
        if (!r.body) {
          console.error(r.body);
          this.toastService.showToast(
            'danger',
            'Problem getting survey history'
          );
        } else {
          this.surveys = r.body.reverse();
        }
      },
      error: (error) => {
        console.error(error, this);
        this.isSurveyHistoryLoading = false;
        this.toastService.showToast('danger', 'Problem getting survey history');
      },
    });
  }

  deleteSurvey(m: ClientSurveyModel) {
    this.isDeleting = true;

    let deleteresponseparams: DeleteSurveyResponsesAsync$Json$Params = {
      body: {
        deleteBySurvey: true,
        surveyId: m.surveyId
      }
    };

    this.surveyResponseService.deleteSurveyResponsesAsync$Json$Response(deleteresponseparams).subscribe({
      next: (responses) => {
        console.log('responses', responses);
        if (responses.body !== 0 && !responses.body) {
          this.toastService.showToast('danger', 'Problem deleting survey responses');
          this.isDeleting = false;
        }
        else {
          let deleteversionparams: DeleteSurveyVersionsAsync$Json$Params = {
            surveyId: m.surveyId!
          };

          this.surveyVersionService.deleteSurveyVersionsAsync$Json$Response(deleteversionparams).subscribe({
            next: (versions) => {
              if (!versions.body) {
                this.toastService.showToast('danger', 'Problem deleting survey versions');
                this.isDeleting = false;
              }
              else {
                let deletesurveyparams: DeleteSurveyAsync$Json$Params = {
                  surveyId: m.surveyId!
                };
                this.surveyService.deleteSurveyAsync$Json$Response(deletesurveyparams).subscribe({
                  next: (s) => {
                    if (!s.body) {
                      this.toastService.showToast('danger', 'Problem deleting survey');
                      this.isDeleting = false;
                    }
                    else {
                      this.toastService.showToast('success', 'Survey deleted successfully');
                      this.loadSurveyHistory();
                    }
                  },
                  error: (e) => {
                    console.error(e, this);
                    this.toastService.showToast('danger', 'Problem deleting survey');
                    this.isDeleting = false;
                  }
                });
              }
            },
            error: (e) => {
              console.error(e, this);
              this.toastService.showToast('danger', 'Problem deleting survey versions');
              this.isDeleting = false;
            }
          });
        }
      },
      error: (e) => {
        console.error(e, this);
        this.toastService.showToast('danger', 'Problem deleting survey responses');
        this.isDeleting = false;
      }
    });
  }

  doesSurveyNeedApproval(m: ClientSurveyModel) {
    if (!m.versions) {
      return false;
    } else {
      return m.versions.filter((x) => x.isDraft).length > 0;
    }
  }
}
